import { Link } from "react-router-dom";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import Logo from "./Logo";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/subscribe", { email, source: "footer" });
      try { localStorage.setItem("aperture_captured", "1"); } catch {}
      toast.success("You're on the list. Free sample incoming.");
      setEmail("");
    } catch { toast.error("Something went wrong."); }
    setBusy(false);
  };
  return (
    <footer className="bg-navy text-white/80 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-2">
            <Logo size={40} color="#F7F5F0" />
            <div className="font-serif text-2xl text-white">Aperture Enterprises</div>
          </div>
          <p className="mt-3 text-sm text-white/60 max-w-md leading-relaxed">Opening doors to new possibilities. Practical playbooks for creative real estate and housing solutions.</p>
          <form onSubmit={submit} className="mt-6 flex max-w-sm gap-2" data-testid="footer-newsletter-form">
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder="your@email.com" data-testid="footer-newsletter-email" className="flex-1 px-4 py-2.5 bg-white/5 border border-white/15 text-white placeholder-white/40 text-sm focus:outline-none focus:border-gold rounded-sm" />
            <button disabled={busy} data-testid="footer-newsletter-submit" className="px-5 py-2.5 bg-gold text-navy text-xs uppercase tracking-widest font-medium hover:bg-white transition-colors duration-300 rounded-sm">Join</button>
          </form>
        </div>
        <div>
          <div className="eyebrow text-white/50 mb-4" style={{ color: "#C4A265" }}>Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/catalog" className="hover:text-gold transition-colors">Catalog</Link></li>
            <li><Link to="/affiliates" className="hover:text-gold transition-colors">Affiliate Program</Link></li>
            <li><Link to="/library" className="hover:text-gold transition-colors">My Library</Link></li>
            <li><Link to="/login" className="hover:text-gold transition-colors">Sign In</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4" style={{ color: "#C4A265" }}>Contact</div>
          <ul className="space-y-2 text-sm text-white/60">
            <li>hello@apertureent.com</li>
            <li>Aperture Enterprises, LLC</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 text-xs text-white/40 flex flex-col md:flex-row justify-between items-center gap-2">
          <div>© {new Date().getFullYear()} Aperture Enterprises, LLC. All rights reserved.</div>
          <div>Opening doors to new possibilities.</div>
        </div>
      </div>
    </footer>
  );
}
